import * as core from '../../../../../../../core'
import * as changeImpactFunctionalArea from '../change-impact-functional-area'

export const RESOURCE = {
  payload: {
    description: 'Project Management',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactFunctionalArea.RESOURCE.payload.partialId,
    }),
    id: 'Project Management',
    name: 'Project Management',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
